import { useEffect } from 'react';

import { deleteLocalStorage } from '@zola-helpers/client/dist/es/util/storage';

import { VENDOR_FAVORITE_ONBOARD_STOREFRONT_UUID_KEY } from './useOnboardedViaFavoritedStorefront';

export type UseScrollToVendorCardProps = {
  ready: boolean;
  favoritedStorefrontUuid: string | null;
};
export const useScrollToVendorCard = (props: UseScrollToVendorCardProps) => {
  const { ready, favoritedStorefrontUuid } = props;
  useEffect(() => {
    if (ready && favoritedStorefrontUuid) {
      const vendorCard = document.getElementById(`vendor-card-${favoritedStorefrontUuid}`);
      if (vendorCard) {
        vendorCard.scrollIntoView({ block: 'end' });
      }
      deleteLocalStorage(VENDOR_FAVORITE_ONBOARD_STOREFRONT_UUID_KEY);
    }
  }, [ready, favoritedStorefrontUuid]);
};
